export type ScheduledCampaignStatus =
  | 'pending'
  | 'queued'
  | 'processing'
  | 'completed'
  | 'failed'
  | 'cancelled'
  | 'partially_completed'
  | 'paused';

export interface ScheduledCampaign {
  id: string;
  campaign_name?: string;
  subject: string;
  recipient_count: number;
  scheduled_at: string;
  status: ScheduledCampaignStatus;
  successful_sends?: number;
  failed_sends?: number;
  error_message?: string;
  created_at?: string;
  processed_at?: string;
  updated_at?: string;
  retry_count?: number;
  max_retries?: number;
  next_retry_at?: string | null;
  paused_at?: string | null;
  progress_percentage?: number;
  timezone?: string;
  processed_count?: number;
  started_at?: string | null;
  completed_at?: string | null;
  estimated_completion_at?: string | null;
  open_count?: number;
  click_count?: number;
  bounce_count?: number;
  unsubscribe_count?: number;
}

export interface CampaignLogEntry {
  id: string;
  campaign_id: string;
  level: 'info' | 'warn' | 'error';
  message: string;
  meta?: Record<string, unknown>;
  created_at: string;
}

export interface BulkEmailSendConfig {
  sendDelayMs: number;
  minDelayMs: number;
  maxDelayMs: number;
  batchProgressEvery: number;
}

export const COMMON_TIMEZONES = [
  'UTC',
  'Asia/Kolkata',
  'Asia/Dubai',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Europe/London',
  'Europe/Paris',
  'America/New_York',
  'America/Los_Angeles',
  'Australia/Sydney',
] as const;
